import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Link, Select, Skeleton } from 'wtb-components';
import { useAppContext, useLocaleContext, useTransactionContext } from 'context';
import styles from './Header.module.css';

const MerchantTitle = () => {
  const location = useLocation();

  const { merchant, links } = useTransactionContext();

  const logo = merchant.logo || merchant.logoPath || links?.merchant?.logo;

  if (logo) {
    if (location.pathname.includes('success') && links?.merchant?.website) {
      return (
        <Link
          className={styles.merchantLink}
          href={links.merchant.website}
          color="tertiary"
          target="_blank"
        >
          <img
            className={styles.merchantLogo}
            src={logo}
            alt={`${merchant.name} logo`}
          />
        </Link>
      );
    } else {
      return (
        <img
          className={styles.merchantLogo}
          src={logo}
          alt={`${merchant.name} logo`}
        />
      );
    }
  } else {
    return <div className={styles.merchantLogo}>{merchant.name}</div>;
  }
};

const Header = () => {
  const { merchant } = useTransactionContext();
  const { isDownload, isLoading } = useAppContext();
  const {
    availableLanguages,
    locale,
    locales,
    getLocaleName,
    getLocaleFlag,
    changeLocale
  } = useLocaleContext();

  const [ languageSelectorItems, setLanguageSelectorItems ] = useState([]);

  useEffect(() => {
    if (!availableLanguages || !locales || languageSelectorItems.length) return;

    setLanguageSelectorItems(availableLanguages.map((lang) => ({
      value: lang,
      text: getLocaleName(lang),
      image: getLocaleFlag(lang),
      imageName: `${getLocaleName(lang)} (${lang})`,
      name: lang
    })));
  }, [
    languageSelectorItems,
    setLanguageSelectorItems,
    availableLanguages,
    getLocaleFlag,
    getLocaleName,
    locales
  ]);

  const shouldRenderSelect = (
    !isDownload()
    && availableLanguages
    && availableLanguages.length > 1
    && locale
    && getLocaleFlag(locale)
  );

  return (
    <div className={styles.root}>
      <>
        {(merchant && !isLoading)
          ? <MerchantTitle />
          : <Skeleton width={200} height={50} />}
      </>

      {shouldRenderSelect && (
        <Select
          className={styles.languageSelector}
          variant="standard"
          underline={false}
          items={languageSelectorItems}
          value={locale}
          onChange={(e) => changeLocale(e.target.value)}
          renderValue={(value) => (
            <img
              className={styles.flag}
              alt={`${getLocaleName(value)} flag`}
              src={getLocaleFlag(value)}
            />
          )}
        />
      )}
    </div>
  );
};

export default Header;
